/* global axios */
export const requestNetworkPanelContext = ({
  accountId,
  conversationId,
  signal,
}) =>
  axios.post(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/network_panel_context`,
    {},
    { signal }
  );
